// extracted by mini-css-extract-plugin
module.exports = {"infoIconStyle":"customerActivityV2Styles_infoIconStyle__2TXYy"};